import * as React from 'react';
import { Mail } from 'lucide-react';
import { useT } from '../lib/i18n.js';
import type { MailboxStripModel } from '../lib/mail-cards.js';

/**
 * Krok AS1 bod 5 — pás nad tabulí Úkoly (předloha `tabule/Ukoly.png`):
 * „Schránka <adresa> · připojeno · N roztříděno: X potřebují tebe · Y
 * spárováno · Z bez akce · kontrola HH:MM · Nastavit" a slib „Nic neodesílá,
 * neoznačuje jako přečtené." Věty jsou celé z katalogu, čísla se jen dosadí.
 */
export function MailboxStrip({
  model,
  onSettings,
}: {
  readonly model: MailboxStripModel;
  /** Tlacitko Nastavit vede do Nastaveni, sekce Schranka (navigaci dela tabule). */
  readonly onSettings: () => void;
}): React.JSX.Element {
  const t = useT();
  const checked =
    model.checkedAt === null
      ? t('webAdmin.mailbox.strip.notChecked')
      : t('webAdmin.mailbox.strip.checked', {
          time: new Intl.DateTimeFormat('cs-CZ', { hour: 'numeric', minute: '2-digit' }).format(new Date(model.checkedAt)),
        });
  return (
    <section className="rh-a2-mstrip" data-testid="mailbox-strip" aria-label={t('webAdmin.mailbox.title')}>
      <span className="rh-a2-mstrip__ico" aria-hidden="true">
        <Mail size={18} strokeWidth={1.9} />
      </span>
      <div className="rh-a2-mstrip__body">
        <div className="rh-a2-mstrip__head">
          <strong>{t('webAdmin.mailbox.strip.title', { address: model.address })}</strong>{' '}
          <span className={`rh-a2-mstrip__state rh-a2-mstrip__state--${model.state}`} data-testid="mailbox-strip-state">
            {t(`webAdmin.mailbox.status.${model.state}` as 'webAdmin.mailbox.status.connected')}
          </span>
        </div>
        <p className="rh-a2-meta" data-testid="mailbox-strip-summary">
          {t('webAdmin.mailbox.strip.summary', {
            today: model.today,
            needsYou: model.needsYou,
            matched: model.matched,
            noAction: model.noAction,
          })}{' '}
          {t('webAdmin.mailbox.strip.promise')}
        </p>
      </div>
      <span className="rh-a2-meta rh-a2-mstrip__checked" data-testid="mailbox-strip-checked">
        {checked}
      </span>
      <button type="button" className="rh-a2-btn rh-a2-btn--sm" data-testid="mailbox-strip-settings" onClick={onSettings}>
        {t('webAdmin.mailbox.strip.settings')}
      </button>
    </section>
  );
}
